import { useDebounce } from '@valiant/ui-shared'
import { useQueryParams } from '@valiant/ui-shared'
import { LogsTable } from '@/components/tables/LogsTable'
import { TabsHeader, TabsHeaderTitle } from '@valiant/ui-shared'

interface LogsTabProps {
  userId?: string
  searchTerm?: string
}

export function LogsTab({ userId, searchTerm }: LogsTabProps) {
  const queryParams = useQueryParams()
  const searchInput = searchTerm || queryParams.search || ''

  // Use the existing debounce hook
  const debouncedSearch = useDebounce(searchInput)

  return (
    <div className="space-y-4">
      <TabsHeader>
        <TabsHeaderTitle>{userId ? 'User Activity Logs' : 'System Audit Logs'}</TabsHeaderTitle>
      </TabsHeader>

      <LogsTable userId={userId} debouncedSearch={debouncedSearch} />
    </div>
  )
}
